<template>
  <div
    class="bg-background-warning-accent flex items-center space-x-1 rounded-3xl py-1 pr-2 pl-1"
  >
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.81295 8.92196L8.5655 1.59395C8.979 1.0672 9.82399 1.41064 9.75277 2.0765L9.33313 6.00028H12.6687C13.2248 6.00028 13.5365 6.64118 13.193 7.07863L7.43371 14.4142C7.02022 14.9409 6.17533 14.5975 6.24646 13.9317L6.66646 10.0003H3.33734C2.78119 10.0003 2.46954 9.35942 2.81295 8.92196Z"
        fill="url(#paint0_linear_12581_60162)"
      />
      <path
        d="M6.2469 13.9314L6.6669 10L9.33357 6H12.6691C13.2253 6 13.5369 6.6409 13.1935 7.07836L7.43416 14.4139C7.02066 14.9406 6.17577 14.5972 6.2469 13.9314Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_12581_60162"
          x1="-4.70964"
          y1="25.4026"
          x2="17.6736"
          y2="19.2641"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#ECECEC" stop-opacity="0.2" />
          <stop offset="1" stop-color="white" />
        </linearGradient>
      </defs>
    </svg>

    <span class="text-static-white text-xs font-medium">{{
      t('freeLabel.title')
    }}</span>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import messages from './config/locales.json';

  const { t } = useI18n({ messages });
</script>
